/**
 * Codificación URL-safe base64 para IDs de lista (emails, claves de grupo JSON).
 * Oculta el contenido en la URL sin cambiar el modelo de datos.
 *
 * encodeListParam("alice@example.com")          → "YWxpY2VAZXhhbXBsZS5jb20"
 * encodeListParam('["a@b.com","c@d.com"]')       → "WyJhQGIuY29tIiwiY0BkLmNvbSJd"
 * decodeListParam("YWxpY2VAZXhhbXBsZS5jb20")    → "alice@example.com"
 */
export function encodeListParam(str) {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function decodeListParam(str) {
  if (!str) return str;
  // Compatibilidad con URLs antiguas (formato sin codificar)
  if (str === '__private' || str.includes('@') || str.startsWith('[')) return str;
  try {
    const padded = str + '='.repeat((4 - (str.length % 4)) % 4);
    return atob(padded.replace(/-/g, '+').replace(/_/g, '/'));
  } catch {
    return str;
  }
}
